import { render, staticRenderFns } from "./btnLargo.vue?vue&type=template&id=409d566e&scoped=true&"
import script from "./btnLargo.vue?vue&type=script&lang=js&"
export * from "./btnLargo.vue?vue&type=script&lang=js&"
import style0 from "./btnLargo.vue?vue&type=style&index=0&id=409d566e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409d566e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VContainer})
